// import { useEffect, useState } from "react"

import { Page, Text, View, Document, Image } from '@react-pdf/renderer';

import { styles } from './styles/styles';
import { Header, Header2 } from './common/header';
// import { FooterStyle2 } from "./common/footer"
// import { BodyTopStyle2 } from './common/bodyTop';
// import { BodyMainHeaderStyle1 } from './common/bodyMainHeader';
import { BodyMainFooterStyle1 } from './common/bodyMainFooter';
import { BodyMainRowStyle1 } from './common/bodyMainRow';

// config
const _documentLabel = "PACKAGE LABEL";

const RenderBodyMain = ({ pageNumber, totalPages, data, document }) => {

    return (
        <View
            style={{
                fontWeight: 800
            }}
        >
            {/* <BodyMainHeaderStyle1 /> */}
            <View style={{ width: '100%' }}>
                <BodyMainRowStyle1 data={data} pageNumber={pageNumber} />
            </View>
            {/* {
                (pageNumber === totalPages) &&
                <BodyMainFooterStyle1 document={document} data={data} summary={summary} />
            } */}
            <BodyMainFooterStyle1 pageNumber={pageNumber} totalPages={totalPages} document={document} data={data} />
        </View>
    )
}

const RenderHeader = (props) => {

    const { pageVariants } = props
    
    if(pageVariants.renderDataType === "6x6"){

        return (
            <Header2
                {...props}
                document={{
                    documentName: _documentLabel
                }}
            />
        )

    }

    return (
        <Header 
            {...props}
            document={{
                documentName: _documentLabel
            }}
        />
    )
}

const RenderPage = ({ pageVariants, pageNumber, totalPages, data, document }) => {

    if(pageVariants.renderDataType === "6x6"){
        return (
            <Page 
                // size="B8" 
                style={styles.page} 
                wrap
                size={{
                    width: 175.75, 
                    height: 175.75,
                }}
            >
                {/* <View render={(props) => <RenderHeader {...props} document={document} data={data} /> } fixed /> */}
                <RenderHeader pageVariants={pageVariants} totalPages={totalPages} pageNumber={pageNumber} document={document} data={data} />
                {/* <BodyTopStyle2 pageNumber={pageNumber} totalPages={totalPages} document={document} /> */}
                {/* <RenderBodyMain pageVariants={pageVariants} pageNumber={pageNumber} totalPages={totalPages} document={document} data={data} /> */}
                {/* <FooterStyle2 document={document} /> */}
            </Page>
        )
    }

    return (
        <Page 
            // size="A6" 
            style={styles.page} 
            wrap
            size={{
                width: 297.64, 
                height: 297.64,
            }}
        >
            {/* <View render={(props) => <RenderHeader {...props} document={document} data={data} /> } fixed /> */}
            <RenderHeader pageVariants={pageVariants} totalPages={totalPages} pageNumber={pageNumber} document={document} data={data} />
            {/* <BodyTopStyle2 pageNumber={pageNumber} totalPages={totalPages} document={document} /> */}
            <RenderBodyMain pageNumber={pageNumber} totalPages={totalPages} document={document} data={data} />
            {/* <FooterStyle2 document={document} /> */}
        </Page>
    )
}

export function Output(props){

    const { document, data, pageVariants } = props

    return (
        <Document
            title={document?.title}
        >
            {
                data.map((i, index) => {

                    // const startFrom = index === 0? 0 : index * rowPerPage
                    // const startTo = index === 0? rowPerPage : startFrom + rowPerPage

                    // // slide the needed array subset data
                    // const data = _items.slice(startFrom, startTo)

                    return (
                        <RenderPage 
                            pageVariants={pageVariants}
                            pageNumber={(index+1)} 
                            totalPages={data.length} 
                            // account={account}
                            // document={_document} 
                            // header={_documentHeader}
                            data={i} 
                            key={index}
                            // summary={summary}
                        />
                    )
                })
            }
        </Document>
        // <div>Hello World</div>
    )
}